const broker_dealers = [
    { text: 'None', value: '0' },
    { text: 'Allstate Financial Services LLC', value: '1' },
    { text: 'American Portfolios Financial Services Inc.', value: '2' },
    { text: 'Ameriprise Financial Services Inc.', value: '3' },
    { text: 'Ameritas Investment Corp.', value: '4' },
    { text: 'Arete Wealth Management', value: '5' },
    { text: 'Ausdal Financial Partners', value: '6' },
    { text: 'AXA Advisors LLC', value: '7' },
    { text: 'BCG Securities, Inc.', value: '8' },
    { text: 'Bernardi Securities Inc.', value: '9' },
    { text: 'Berthel Fisher & Co. Financial Services Inc.', value: '10' },
    { text: 'Bolton Global Capital', value: '11' },
    { text: 'Broker Dealer Financial Services Corp.', value: '12' },
    { text: 'Cadaret, Grant & Co. Inc.', value: '13' },
    { text: 'Calton & Associates Inc.', value: '14' },
    { text: 'Cambridge Investment Research Inc.', value: '15' },
    { text: 'Cantella & Co. Inc.', value: '16' },
    { text: 'Capital Analysts Inc.', value: '17' },
    { text: 'Capital Investment Co.', value: '18' },
    { text: 'Centaurus Financial Inc.', value: '19' },
    { text: 'Century Securities Associates Inc.', value: '20' },
    { text: 'Cetera Advisor Networks', value: '21' },
    { text: 'Cetera Advisors', value: '22' },
    { text: 'Cetera Financial Institutions', value: '23' },
    { text: 'Cetera Financial Specialists', value: '24' },
    { text: 'CFD Investments Inc.', value: '25' },
    { text: 'Commonwealth Financial Network', value: '26' },
    { text: 'Coordinated Capital Securities Inc.', value: '27' },
    { text: 'Correll Co. Investment Services Corp.', value: '28' },
    { text: 'Crown Capital Securities L.P.', value: '29' },
    { text: 'CUNA Brokerage Services Inc.', value: '30' },
    { text: 'Cutter & Co. Inc.', value: '31' },
    { text: 'D.A. Davidson & Co.', value: '32' },
    { text: 'David A. Noyes & Company', value: '33' },
    { text: 'Edward Jones', value: '34' },
    { text: 'Equity Services Inc.', value: '35' },
    { text: 'Finance 500 Inc.', value: '36' },
    { text: 'Financial Services International Corp.', value: '37' },
    { text: 'Financial Telesis Inc.', value: '38' },
    { text: 'First Allied Securities, Inc.', value: '39' },
    { text: 'First Republic Securities Co.', value: '40' },
    { text: 'Foothill Securities Inc.', value: '41' },
    { text: 'Foresters Equity Services Inc.', value: '42' },
    { text: 'Fortune Financial Services, Inc.', value: '43' },
    { text: 'Founders Financial Securities, LLC', value: '44' },
    { text: 'FSC Securities Corp.', value: '45' },
    { text: 'H. Beck Inc.', value: '46' },
    { text: 'Hilltop Securities Independent Network Inc.', value: '47' },
    { text: 'Hornor Townsend & Kent Inc.', value: '48' },
    { text: 'Independent Financial Group LLC', value: '49' },
    { text: 'Infinity Financial Services', value: '50' },
    { text: 'ING Advisor Network Inc.', value: '51' },
    { text: 'INVEST Financial Corp.', value: '52' },
    { text: 'Investacorp Inc.', value: '53' },
    { text: 'Investment Centers of America Inc.', value: '54' },
    { text: 'J.W. Cole Financial Inc.', value: '55' },
    { text: 'Kestra Financial, Inc', value: '56' },
    { text: 'KMS Financial Services, Inc.', value: '57' },
    { text: 'LaSalle St. Securities LLC', value: '58' },
    { text: 'Leaders Group', value: '59' },
    { text: 'Leonard & Co.', value: '60' },
    { text: 'LifeMark Securities Corp.', value: '61' },
    { text: 'Lincoln Financial Network', value: '62' },
    { text: 'LPL Financial LLC', value: '63' },
    { text: 'MML Investors Services, LLC', value: '64' },
    { text: 'National Planning Corporation (NPC)', value: '65' },
    { text: 'Nationwide Planning Associates, Inc.', value: '66' },
    { text: 'NEXT Financial Group Inc.', value: '67' },
    { text: 'Packerland Brokerage Services Inc.', value: '68' },
    { text: 'Royal Alliance Associates Inc.', value: '69' },
    { text: 'Signator Investors Inc.', value: '70' },
    { text: 'The Strategic Financial Alliance Inc.', value: '71' },
    { text: 'Wells Fargo Advisors Financial Network', value: '72' },
    { text: 'Williams Financial Group', value: '73' },
    { text: 'Woodbury Financial Services', value: '74' },
    { text: 'Other', value: '75' }
];

const compensation_methods = [
    { text: 'W-2 & 1099', value: '0' },
    { text: '1099 Contractor', value: '1' },
    { text: 'W-2 Salary', value: '2' }
];

const custodians = [
    { text: 'None', value: '0' },
    { text: 'Apex Clearing Corp.', value: '1' },
    { text: 'COR Clearing', value: '2' },
    { text: 'First Clearing', value: '3' },
    { text: 'Folio Institutional', value: '4' },
    { text: 'Goldman Sachs Execution & Clearing', value: '5' },
    { text: 'Interactive Brokers', value: '6' },
    { text: 'LPL Financial', value: '7' },
    { text: 'Merrill Lynch Professional Clearing Corp. & Broadcort', value: '8' },
    { text: 'National Advisors Trust Co.', value: '9' },
    { text: 'National Financial Services Fidelity Clearing and Custody', value: '10' },
    { text: 'Pershing', value: '11' },
    { text: 'Pershing Advisors Solutions', value: '12' },
    { text: 'Raymond James & Associates Inc.', value: '13' },
    { text: 'RBC Advisor Services', value: '14' },
    { text: 'RBC Correspondent Services', value: '15' },
    { text: 'Schwab Advisor Services', value: '16' },
    { text: 'Scottrade Advisor Services', value: '17' },
    { text: 'Shareholders Service Group', value: '18' },
    { text: 'Southwest Securities Inc.', value: '19' },
    { text: 'Sterne Agee Clearing Inc.', value: '20' },
    { text: 'TD Ameritrade Institutional', value: '21' },
    { text: 'Trade-PMR Inc.', value: '22' },
    { text: 'Trust Company of America', value: '23' },
    { text: 'U.S. Bank', value: '24' },
    { text: 'Wedbush Securities Inc.', value: '25' },
    { text: 'Other', value: '26' }
];

const employee_roles = [
    { text: 'Client-Facing', value: '0' },
    { text: 'Administrative', value: '1' },
    { text: 'Both Client-Facing and Administrative', value: '2' },
    { text: 'Producing Advisor', value: '3' },
    { text: 'Non-Producing Advisor', value: '4' }
];

const employee_status = [
    { text: 'Temp', value: '0' },
    { text: 'Full Time', value: '1' },
    { text: 'Intern', value: '2' },
    { text: 'Part Time', value: '3' },
    { text: 'No Longer With Firm', value: '4' },
    { text: 'Retired', value: '5' }
];

const entity_types = [
    { text: 'Sole Proprietorship', value: '1' },
    { text: 'Limited Liability Company (LLC)', value: '2' },
    { text: 'S Corporation', value: '3' },
    { text: 'C Corporation', value: '4' },
    { text: 'Limited Liability Partnership (LLP)', value: '5' }
];

const financials_prepared = [
    { text: 'Internal Bookkeeper/Accountant', value: '0' },
    { text: 'Audited Financial Statements', value: '1' },
    { text: 'Compilation (by CPA)', value: '2' },
    { text: 'External CPA', value: '3' },
    { text: 'Internal CPA', value: '4' },
    { text: 'External Bookkeeper/Accountant', value: '5' },
    { text: 'Self-Prepared', value: '6' }
];

const frequency = [
    { text: 'Monthly or more', value: '0' },
    { text: 'Quarterly', value: '1' },
    { text: 'Tri-Annually', value: '2' },
    { text: 'Semi-Annually', value: '3' },
    { text: 'Annually', value: '4' },
    { text: 'Less than anually', value: '5' }
];

const owner_roles = [
    { text: 'Licensed Non-Producing Owner', value: '0' },
    { text: 'Non-licensed Owner', value: '1' },
    { text: 'Passive Owner', value: '2' },
    { text: 'Retired', value: '3' },
    { text: 'No longer with firm', value: '4' },
    { text: 'Licensed Producing Owner', value: '5' }
];

const purpose = [
    { text: 'Succession Plan', value: '1' },
    { text: 'Equity Sharing', value: '2' },
    { text: 'Entity Formation', value: '3' },
    { text: 'Dispute', value: '4' },
    { text: 'Divorce', value: '5' },
    { text: 'Adding a Partner', value: '6' },
    { text: 'Lending', value: '7' },
    { text: 'Buying Business', value: '8' },
    { text: 'Selling Business', value: '9' },
    { text: 'Annual Valuation', value: '10' },
    { text: 'Merger', value: '11' },
    { text: 'Benchmarking', value: '12' },
    { text: 'Death/Disability', value: '13' },
    { text: 'I have a different purpose', value: '14'}
];

const software_account_aggregation = [
    { text: 'None', value: '0' },
    { text: 'Albridge Wealth Reporting', value: '1' },
    { text: 'ByAllAccounts', value: '2' },
    { text: 'eMoney 360', value: '3' },
    { text: 'Fiserv', value: '4' },
    { text: 'Total View', value: '5' },
    { text: 'YODLEE', value: '6' },
    { text: 'Other', value: '7' }
];

const software_accounting = [
    { text: 'None', value: '0' },
    { text: 'Excel', value: '1' },
    { text: 'Freshbooks', value: '2' },
    { text: 'QuickBooks', value: '3' },
    { text: 'Quicken', value: '4' },
    { text: 'Wave Accounting', value: '5' },
    { text: 'Xero', value: '6' },
    { text: 'Zoho Books', value: '7' },
    { text: 'Other', value: '8' }
];

const software_crm = [
    { text: 'None', value: '0' },
    { text: 'ACT!', value: '1' },
    { text: 'Contact Manager', value: '2' },
    { text: 'Junxure', value: '3' },
    { text: 'Microsoft Dynamics', value: '4' },
    { text: 'Redtail', value: '5' },
    { text: 'Salesforce', value: '6' },
    { text: 'Other', value: '7' }
];

const software_document_management = [
    { text: 'None', value: '0' },
    { text: 'Box', value: '1' },
    { text: 'Broker-Dealer Platform', value: '2' },
    { text: 'LaserApp', value: '3' },
    { text: 'Laserfiche', value: '4' },
    { text: 'Online File Manager', value: '5' },
    { text: 'Redtail Imaging', value: '6' },
    { text: 'Worldox', value: '7' },
    { text: 'Other', value: '8' }
];

const software_financial_planning = [
    { text: 'None', value: '0' },
    { text: 'eMoney', value: '1' },
    { text: 'MoneyGuidePro', value: '2' },
    { text: 'Morningstar Advisor Workstation', value: '3' },
    { text: 'NaviPlan Select', value: '4' },
    { text: 'Proprietary', value: '5' },
    { text: 'WealthVision', value: '6' },
    { text: 'Other', value: '7' }
];

const software_portfolio_rebalancing = [
    { text: 'None', value: '0' },
    { text: 'Axys', value: '1' },
    { text: 'Envestnet', value: '2' },
    { text: 'iRebal', value: '3' },
    { text: 'Proprietary', value: '4' },
    { text: 'Schwab Portfolio Rebalancer', value: '5' },
    { text: 'Tamarac', value: '6' },
    { text: 'Thomson One', value: '7' },
    { text: 'TRX', value: '8' },
    { text: 'Other', value: '9' }
];

const states = [
    { "text": "Alabama", "value": "AL" },
    { "text": "Alaska", "value": "AK" },
    { "text": "Arizona", "value": "AZ" },
    { "text": "Arkansas", "value": "AR" },
    { "text": "California", "value": "CA" },
    { "text": "Colorado", "value": "CO" },
    { "text": "Connecticut", "value": "CT" },
    { "text": "Delaware", "value": "DE" },
    { "text": "District Of Columbia", "value": "DC" },
    { "text": "Florida", "value": "FL" },
    { "text": "Georgia", "value": "GA" },
    { "text": "Hawaii", "value": "HI" },
    { "text": "Idaho", "value": "ID" },
    { "text": "Illinois", "value": "IL" },
    { "text": "Indiana", "value": "IN" },
    { "text": "Iowa", "value": "IA" },
    { "text": "Kansas", "value": "KS" },
    { "text": "Kentucky", "value": "KY" },
    { "text": "Louisiana", "value": "LA" },
    { "text": "Maine", "value": "ME" },
    { "text": "Maryland", "value": "MD" },
    { "text": "Massachusetts", "value": "MA" },
    { "text": "Michigan", "value": "MI" },
    { "text": "Minnesota", "value": "MN" },
    { "text": "Mississippi", "value": "MS" },
    { "text": "Missouri", "value": "MO" },
    { "text": "Montana", "value": "MT" },
    { "text": "Nebraska", "value": "NE" },
    { "text": "Nevada", "value": "NV" },
    { "text": "New Hampshire", "value": "NH" },
    { "text": "New Jersey", "value": "NJ" },
    { "text": "New Mexico", "value": "NM" },
    { "text": "New York", "value": "NY" },
    { "text": "North Carolina", "value": "NC" },
    { "text": "North Dakota", "value": "ND" },
    { "text": "Ohio", "value": "OH" },
    { "text": "Oklahoma", "value": "OK" },
    { "text": "Oregon", "value": "OR" },
    { "text": "Pennsylvania", "value": "PA" },
    { "text": "Rhode Island", "value": "RI" },
    { "text": "South Carolina", "value": "SC" },
    { "text": "South Dakota", "value": "SD" },
    { "text": "Tennessee", "value": "TN" },
    { "text": "Texas", "value": "TX" },
    { "text": "Utah", "value": "UT" },
    { "text": "Vermont", "value": "VT" },
    { "text": "Virginia", "value": "VA" },
    { "text": "Washington", "value": "WA" },
    { "text": "West Virginia", "value": "WV" },
    { "text": "Wisconsin", "value": "WI" },
    { "text": "Wyoming", "value": "WY" }
];

const third_party_asset_managers = [
    { text: 'None', value: '0' },
    { text: 'AssetMark', value: '1' },
    { text: 'Axxcess Wealth Management, LLC', value: '2' },
    { text: 'Brinker Capital, Inc.', value: '3' },
    { text: 'Brookstone Capital Management', value: '4' },
    { text: 'Cornerstone Wealth Management, LLC', value: '5' },
    { text: 'D Asset Management, Inc.', value: '6' },
    { text: 'Dunham & Associates', value: '7' },
    { text: 'Envestnet', value: '8' },
    { text: 'EQIS', value: '9' },
    { text: 'Flexible Plan Investments, Ltd.', value: '10' },
    { text: 'FTJ FundChoice, LLC', value: '11' },
    { text: 'Lindner Capital Advisors, Inc.', value: '12' },
    { text: 'Sawtooth Solutions, LLC', value: '13' },
    { text: 'SEI', value: '14' },
    { text: 'SMArtX Advisory Solutions', value: '15' },
    { text: 'Sowell Management', value: '16' },
    { text: 'TownSquare Capital, LLC', value: '17' },
    { text: 'USA Financial Exchange', value: '18' },
    { text: 'Other', value: '19' }
];

const titles = [
    { "text": "Non-licensed employee/administrative", "value": 336, "description": null },
    { "text": "Licensed Producing Advisor", "value": 334, "description": null },
    { "text": "Chief Executive Officer (CEO)", "value": 142, "description": "Develops new business, manages relationships, provides advice and, in some cases, services clients. Serves as the head of the firm and makes leadership, planning and broad executive management decisions to achieve the firm's strategic objectives." },
    { "text": "President", "value": 143, "description": "Responsible for the implementation of the business plan of the firm and the day-to-day running of the business, including both advisory and operations functions. Works closely with the CEO on key management decisions. Typically supervises other executives such as COO and Chief Practice Officer. The position is more typical for large firm with larger body of owners and executives." },
    { "text": "Chief Operations Officer (COO)", "value": 144, "description": "Has primary responsibility for the firm's operations. In some cases, develops new business, manages relationships, provides advice or services clients." },
    { "text": "Chief Investment Officer (CIO)", "value": 145, "description": "Plans and directs all aspects of a firm's investment program. Oversees the research and evaluation of investment vehicles and has responsibility for selecting investments that align with the firm's goals." },
    { "text": "Chief Compliance Officer (CCO)", "value": 146, "description": "Develops and monitors the firm's compliance program. Ensures that all activities meet the requirements of state and federal legal and regulatory agencies. Acts as the firm's liaison with agencies on compliance-related issues in response to complaints." },
    { "text": "Chief Marketing Officer (CMO)", "value": 147, "description": "Creates and maintains the firm's marketing and branding initiatives. Oversees all external messaging and communication. Establishes and manages market-positioning strategies and campaigns directed at the firm's target market. In some cases, monitors client satisfaction and feedback to modify the marketing of the firm's services." },
    { "text": "Practicing Partner", "value": 148, "description": "As an owner and principal of the firm, has broad responsibilities in the areas of new business development, client relationships, service and management. With the CEO/partners, makes leadership, planning and executive management decisions to achieve the firm's strategic objectives." },
    { "text": "Business Development Officer (BDO)", "value": 149, "description": "Oversees the firm's business development efforts. Has responsibility for acquiring clients and building referral networks. Makes strategic decisions about target client and market niches, sales events and programs, and the sales process. Manages advisers' sales efforts. In some cases, performs client services." },
    { "text": "Lead Adviser (Level 1)", "value": 150, "description": "Primary managers of the client relationship and are the most experienced advisers in the firm. The position has responsibility for managing existing client relationships, and formulating and implementing advice, but may rely on technical specialists to develop recommendations within an individual specialist's area of expertise. Typically, Lead Advisers are also expected to develop new client relationships and often work with, train and supervise other staff in client service delivery." },
    { "text": "Business Development Specialist", "value": 151, "description": "Generates new business, which is transitioned to an adviser for servicing. Has limited or no client-service responsibility, however typically possesses technical skill as an adviser. Networks with target clients and referral sources. Typically reports to the business development officer or the managing principal." },
    { "text": "Service Adviser (Level 3)", "value": 152, "description": "Manages existing client relationships, in some cases with a more experienced adviser. The position may be responsible for formulating and implementing advice but may also rely on technical specialists to develop recommendations within an individual specialist's area of expertise. Typically, Service Advisers are not expected to develop new client relationships. Position titles vary among firms, but the most common are wealth manager, investment adviser, financial adviser, financial planner and portfolio manager." },
    { "text": "Support Adviser (Level 3)", "value": 153, "description": "Junior adviser/support position that provides technical support for the Lead Adviser or Service Adviser. Responsibilities include data gathering, modeling, case design, scenario building, plan development, presentation development, etc. May participate in client meetings, but not in an advice capacity. Has no decision-making authority on client matters. Position titles vary among firms, but the most common are paraplanners." },
    { "text": "Portfolio Manager", "value": 154, "description": "Actively manages a client portfolio using individual securities or a combination of securities and third-party managers. In some cases, participates in or develops investment strategy. This position is an internal manager, rather than a client relationship manager. Investment-management-focused employees who are primary relationship managers are reported under one of the professional adviser positions. Has less experience than a senior portfolio manager." },
    { "text": "Senior Portfolio Manager", "value": 155, "description": "Actively manages a client portfolio using individual securities or a combination of securities and third-party managers. In some cases, participates in or develops investment strategy. This position is an internal manager, rather than a client relationship manager. Investment-management-focused employees who are primary relationship managers are reported under one of the professional adviser positions." },
    { "text": "Research Analyst", "value": 156, "description": "Researches, analyzes and/or manages investment options. Provides information and makes recommendations to professional staff on managers, advisory service products, investment selection, suitability guidelines and reporting decisions. Has less experience than a senior research analyst." },
    { "text": "Senior Research Analyst", "value": 157, "description": "Researches, analyzes and/or manages investment options. Provides information and makes recommendations to professional staff on managers, advisory service products, investment selection, suitability guidelines and reporting decisions." },
    { "text": "Operations Manager/Office Manager", "value": 158, "description": "Oversees general office operations, such as internal accounting, office equipment and supplies, and benefits and payroll administration. In some cases, manages the firm's website or other marketing tools. This is a catchall position in firms that don't employ separate staff members to do those jobs." },
    { "text": "Marketing Manager", "value": 159, "description": "Has responsibility for the firm's branding and for marketing to clients. Develops and maintains marketing materials, structures campaigns and manages brand development." },
    { "text": "HR Manager", "value": 160, "description": "Manages all employee matters, including complying with labor laws, facilitating worker performance reviews and maintaining personnel files." },
    { "text": "Client Services Administrator", "value": 161, "description": "Has responsibility for maintaining adviser and client files, client reports, contacting clients to provide or obtain updated information, scheduling meetings with professional staff and troubleshooting. Less experienced than a Senior Client Services Administrator." },
    { "text": "Senior Client Services Administrator", "value": 162, "description": "Has responsibility for maintaining adviser and client files, client reports, contacting clients to provide or obtain updated information, scheduling meetings with professional staff and troubleshooting." },
    { "text": "Performance Reporting Analyst", "value": 163, "description": "Maintains the firm's performance reporting system and creates performance and other reports." },
    { "text": "Trader", "value": 164, "description": "Buys and sells securities as directed by the portfolio managers or advisers, or by the chief investment officer." },
    { "text": "Internal Accountant/Bookkeeper", "value": 165, "description": "Has responsibility for internal accounting and for generating the firm's financial statements." },
    { "text": "IT Manager", "value": 166, "description": "Installs, configures and maintains the firm's software and hardware. Provides staff with computer support." },
    { "text": "Executive Assistant", "value": 167, "description": "Provides support to the firm's executives, including maintaining calendars, scheduling appointments, handling correspondence and arranging travel." },
    { "text": "Administrative Assistant", "value": 168, "description": "Performs secretarial and clerical duties, such as typing correspondence, memoranda, reports and meeting notes; scheduling appointments and meetings; and handling photocopying and faxes." },
    { "text": "Receptionist", "value": 169, "description": "Greets and directs clients and other visitors. Screens and routes telephone calls. In some cases, performs incidental typing or other routine clerical duties." }
];

export {
    broker_dealers,
    compensation_methods,
    custodians,
    employee_roles,
    employee_status,
    entity_types,
    financials_prepared,
    frequency,
    owner_roles,
    purpose,
    software_account_aggregation,
    software_accounting,
    software_crm,
    software_document_management,
    software_financial_planning,
    software_portfolio_rebalancing,
    states,
    third_party_asset_managers,
    titles
};


// WEBPACK FOOTER //
// ./src/components/succession-archive/data/data.js